// extracted by mini-css-extract-plugin
module.exports = {"title":"FssShiftStartMessage_title__7uLb4","text":"FssShiftStartMessage_text__1fiI0"};